export const handleValidateYardForm = ({ yardFormData, multiSelectItems, getError, setIsFormValid, setErrors, isHandleSave, }) => {
    const notRequiredFields = ['contactName', 'contactNumber', 'secure'];
    // Only requeued fields
    const yardFormDataFields = Object.entries(yardFormData).filter((yardFordField) => !notRequiredFields.includes(yardFordField[0]));
    const errors = {};
    for (const yardFormDataField of yardFormDataFields) {
        if (!yardFormDataField[1]) {
            errors[yardFormDataField[0]] = getError(yardFormDataField[0]);
        }
    }
    if (!multiSelectItems.length) {
        errors.vendor = getError('vendor');
    }
    const isFormValidWhenSaving = !Object.keys(errors).length && isHandleSave;
    if (isFormValidWhenSaving) {
        setIsFormValid(true);
    }
    setErrors(errors);
};
export const parseValidationError = (errors) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const validationErrorsObject = ((_g = (_f = (_e = (_d = (_c = (_b = (_a = errors[0]) === null || _a === void 0 ? void 0 : _a.graphQLErrors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.extensions) === null || _d === void 0 ? void 0 : _d.exception) === null || _e === void 0 ? void 0 : _e.validationErrors) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.constraints) || {};
    const validationErrorsMessages = Object.values(validationErrorsObject);
    let validationErrorsJoinMessage = '';
    if (validationErrorsMessages.length) {
        validationErrorsJoinMessage = validationErrorsMessages.join('; ');
    }
    return validationErrorsJoinMessage;
};
